import 'typeface-maven-pro';
import './styles/queima-icons.css';
import './font.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import combinedReducers from './reducers';

import App from './App';
import * as serviceWorker from './serviceWorker';

const store = configureStore({ reducer: combinedReducers });

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
